import { render, staticRenderFns } from "./kpUserRole-add.vue?vue&type=template&id=9e7b7dcc&scoped=true"
import script from "./kpUserRole-add.vue?vue&type=script&lang=js"
export * from "./kpUserRole-add.vue?vue&type=script&lang=js"
import style0 from "./kpUserRole-add.vue?vue&type=style&index=0&id=9e7b7dcc&lang=css"
import style1 from "./kpUserRole-add.vue?vue&type=style&index=1&id=9e7b7dcc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7b7dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e7b7dcc')) {
      api.createRecord('9e7b7dcc', component.options)
    } else {
      api.reload('9e7b7dcc', component.options)
    }
    module.hot.accept("./kpUserRole-add.vue?vue&type=template&id=9e7b7dcc&scoped=true", function () {
      api.rerender('9e7b7dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/kpUserRole-add.vue"
export default component.exports